/* eslint-disable import/prefer-default-export */

export const createGroupReportsRequest: (teacherId: string, datasetId: string) => any = (
  teacherId,
  datasetId,
) => ({
  organisation_id: Number(process.env.REACT_APP_LEARNOSITY_ADAPTIVE_ORGANISATION_ID),
  user_id: String(teacherId),
  reports: [
    {
      id: 'sessions-summary-by-group-report',
      type: 'sessions-summary-by-group',
      dataset_id: datasetId,
      group_path: [],
      always_show_group_ancestors: true,
      columns: [
        {
          type: 'group_name',
          label: 'Organization',
        },
        {
          type: 'numeric',
          field: 'population',
          label: '# of Students',
        },
        {
          type: '1d_plot',
          label: 'Results',
          elements: [
            {
              type: 'shading_plot',
              source: 'ancestor_1',
              min: 'p25_percent',
              max: 'p75_percent',
            },
            {
              type: 'line_plot',
              source: 'row',
              score: 50,
              label: false,
            },
            {
              type: 'whisker_plot',
              source: 'row',
              min: 'lowest_percent',
              max: 'highest_percent',
              labels: true,
            },
            {
              type: 'box_plot',
              source: 'row',
              min: 'p25_percent',
              middle: 'median_percent',
              max: 'p75_percent',
              labels: true,
            },
          ],
        },
      ],
      user_columns: [
        {
          type: 'user_id',
        },
        {
          type: 'numeric',
          field: 'score',
        },
        {
          type: '1d_plot',
          label: 'Results',
          elements: [
            {
              type: 'shading_plot',
              source: 'ancestor_1',
              min: 'p25_percent',
              max: 'p75_percent',
            },
            {
              type: 'line_plot',
              source: 'row',
              score: 50,
              label: false,
            },
            {
              type: 'score_plot',
              shape: 'circle',
              source: 'row',
              percent: ['score', 'max_score'],
            },
          ],
        },
      ],
    },
  ],
});
